// extracted by mini-css-extract-plugin
module.exports = {"phone":"phone-number_phone__NkAO1","icon":"phone-number_icon__81XjD"};